<template>
  <div class="dashboard-desktop-col">
    <div id="menu-right" class="dash-sidebar">
      <nav class="dash-sidebar-nav" aria-label="منوی داشبورد">
        <menu-user-widget/>
        <ul class="dash-sidebar-list">
          <item
            v-for="(item,index) in items"
            :key="index"
            :icon="item.icon"
            :id="item.id"
            :item-class="`${item.name}-${$store.getters['User/isAdmin'] ? 'admin' : 'user'}`"
            :access="item.access"
            :module="item.module"
            :action="item.action"
            :name="item.name"
            :route="item.route"
            :badge="item.badge"
            :children="item.children"
          />
          <m-a class="dash-version" target="_blank" href="https://mixitweb.com/release-note">
            <li>
              <span>ورژن:</span>
              {{ appVersion }}
            </li>
          </m-a>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import Item from './item.vue'
import MenuUserWidget from "@/plugin/components/dashboard/DashboardMenu/MenuUserWidget.vue";
import pkg from '../../../../../package.json'

export default {
  name: "desktop",
  components: {MenuUserWidget, Item},
  props: ['items'],
  data() {
    return {
      appVersion: pkg.devDependencies["@moeinmdn/mixitweb-front-modules"]
    }
  },
}
</script>

<style scoped>
.dashboard-desktop-col {
  display: none;
}

@media (min-width: 1281px) {
  .dashboard-desktop-col {
    display: block;
    flex: 0 0 280px;
    width: 280px;
    max-width: 280px;
    min-width: 280px;
    position: sticky;
    top: 12px;
    align-self: flex-start;
    z-index: 2;
    max-height: calc(100vh - 24px);
  }
}

.dash-sidebar {
  position: relative;
  height: 100%;
  max-height: calc(100vh - 24px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #1e1e1e;
  border-radius: 22px;
  box-shadow: 0 16px 36px rgba(30, 30, 30, 0.18);
}

.dash-sidebar::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    radial-gradient(140px 90px at 0% 0%, rgba(235, 61, 96, 0.22), transparent 70%),
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 240 80' preserveAspectRatio='none'%3E%3Cpath fill='%23eb3d60' fill-opacity='0.12' d='M0 46C40 22 80 70 120 48C160 26 200 64 240 42V80H0Z'/%3E%3C/svg%3E") no-repeat bottom / 100% 90px;
}

.dash-sidebar-nav {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: calc(100vh - 24px);
  padding: 12px 10px 14px;
  overflow: hidden;
}

.dash-sidebar-list {
  list-style: none;
  margin: 12px 0 0;
  padding: 0 2px 8px;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  -webkit-overflow-scrolling: touch;
}

.dash-sidebar-list::-webkit-scrollbar {
  width: 6px;
}

.dash-sidebar-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 999px;
}

.dash-version {
  display: block;
  margin-top: 8px;
  padding: 8px 12px;
  color: rgba(255, 255, 255, 0.55) !important;
  text-decoration: none !important;
  font-size: 12px;
}

.dash-version li {
  list-style: none;
}

.dash-version:hover,
.dash-version:focus {
  color: #fff !important;
}
</style>
